import React from 'react';
import AppRouter from './router/AppRouter';
import { store } from './store';
import { Provider } from 'react-redux';
import 'modern-normalize';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "stream-chat-react/dist/css/v2/index.css";
import "@stream-io/video-react-sdk/dist/css/styles.css";
import './App.css';
import Modal from 'react-modal';
import ConfirmModal from './components/ConfirmModal';
import { useAuth } from './hooks/useAuth';
import { AuthenticationStatus } from './store/slices/authSlice';
import Loader from './pages/chat/components/Loader';
import ConnectDialog from './components/ConnectDialog';
import { useApp } from './hooks/useApp';
import { Repository } from './repositories/Repository';
import OtpDialog from './components/OtpDialog';
import StreamContainer from './pages/chat/components/StreamContainer';

Modal.setAppElement('#root');
Repository.init()

const App: React.FC = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <AppWrapper />
      </Provider>
    </React.StrictMode>
  );
};

const AppWrapper = () => {
  const { status } = useAuth();
  useApp();

  if(status !== AuthenticationStatus.INITIAL && status !== AuthenticationStatus.LOGGING_OUT) {
    return (
      <div className="h-screen overflow-hidden">
        <StreamContainer>
          <AppRouter />
          <ConnectDialog />
          <OtpDialog />
          <ConfirmModal />
        </StreamContainer>
      </div>
    );
  }
  else {
    return <div className="h-screen">
      <Loader />
    </div>;
  }
};

export default App;
